<template>
  <div class="mt-2">
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <b-card-header class="esep-card-header">
        <h4 class="float-left text-light font-weight-bold">Ηλεκτρονικές Υπηρεσίες ΣΕΠ</h4>
      </b-card-header>
      <b-card-body>
        Φαίνεται ότι δεν υπάρχει κάτι εδώ.
        Μπορείς να χρησιμοποιήσεις το μενού πάνω αριστερά για να περιηγηθείς στις διαθέσιμες επιλογές σου.
      </b-card-body>
    </div>
  </div>
</template>

<script>
  import {routes} from "../services/routing.service.js";
  // import SelectLocale from '../components/SelectLocale.vue'

export default {
  name: 'home',
  components: {
    // SelectLocale,
  },
  props:{
      username: String,
  },
  data() {
    return {
      routes: routes.routes,
    }
  },
  mounted() {

  }
}
</script>